"use strict";

import "./css/bootstrap.css";
import "./css/jquery-ui.1.12.min.css";
import "./css/bootstrap-timepicker.min.css";
import "./css/custom.css";
import _ from 'underscore';

// import "./js/complaints";

// import complaints from "./js/complaints.js";


import "./js/bootstrap.min.js";
import "./js/jquery-ui.min.js";
import "./js/bootstrap-timepicker.min.js";
import { environment } from "./js/environments/environment";

/**
 * Formerly the code here was in complaints.js - however this all needs to be
 * global stuff - which Webpack doesn't really do.
 * 
 * We get around that by declaring all the functions here as exported, then
 * in the webpack config's output section use libraryTarget: "this" to
 * ensure that it makes these functions globally available.
 */



export function getDaysInMonth(m, y) {
    return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
};
var now = new Date();
var Month = now.getMonth() + 1;
var Day = now.getDate();
var Year = now.getFullYear();
var MinDate;
if (Day > 5) {
    MinDate = 1 - Day;
} else {
    MinDate = 1 - getDaysInMonth(Month, Year) - Day;
    console.log(MinDate);
};
if (Day < 10) {
    Day = '0' + Day;
};
if (Month < 10) {
    Month = '0' + Month;
};
document.getElementById('date').value = '' + Month + '/' + Day + '/' + Year;

// Track whether we are authenticated
var authStatus = undefined;
var addresses = [];
var complaintReasons = [];

var date = $('#date').datepicker({
    minDate: MinDate,
    maxDate: 0
});

$('#flighttracker').attr('href', environment.flighttracker);
$('#flighttracker1').attr('href', environment.flighttracker);

$('#time').timepicker({
    minuteStep: 1,
    disableFocus: true,
    defaultTime: 'current'
});
$('#time').timepicker().on('hide.timepicker', function (e) {
    updateTime();
});

$.ajaxSetup({
    type: "POST",
    data: {},
    dataType: 'json',
    xhrFields: {
       withCredentials: true
    },
    crossDomain: true
});


export function updateAuthStatus(post_update_function) {
    var url = environment.api_host + '/api/auth/user/status/';

    $.ajax({
        url: url,
        type: 'GET',
        contentType: 'application/json',
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            authStatus = data;
            if (authStatus.authenticated) {
                if (authStatus.email) {
                    document.getElementById(span_accountEmail).innerHTML = authStatus.email;
                }
                $.ajax({
                    url: environment.api_host + '/api/crm/1/user-location/',
                    type: 'GET',
                    data: {
                        'date_inactive__isnull': true,
                        'user': authStatus.id
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        addresses = data.objects;
                        populateFormAddresses();
                        if (post_update_function) {
                          post_update_function();
                        }
                    }
                });
                // Get all the complaint reasons and reason codes.
                $.ajax({
                    url: environment.api_host + '/api/crm/1/complaint-reason/',
                    type: 'GET',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        complaintReasons = data.objects;
                        populateFormReasons()
                    }
                });
            } else if (post_update_function) {
                post_update_function();
            }
        }
    });
}


export function hideAllPages() {

    [].forEach.call(document.querySelectorAll('div.box'), function (e) {
        document.getElementById(e.id).style.display = 'none';
    });
}

export function accountAssistance() {

    var email = document.getElementById('helpEmail').value;
    var address = document.getElementById('helpAddress').value;

    var formValidation = true;

    if (email.length < 4) {
        setMessage('helpForm', null, 'alert-warning', 'An email address is required.');
        formValidation = false;
    }

    if (address.length < 4) {
        setMessage('helpForm', null, 'alert-warning', 'An address is required.');
        formValidation = false;
    }

    if (formValidation == true) {
        addLoading('helpForm', 'Saving...');
        var formData = {
            'address': address,
            'email': email
        };

        $.ajax({
            url: environment.api_host + '/api/crm/1/address-help/',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData),
            success: function (data) {
                deleteAll('.loading');
                setMessage('helpForm', null, 'alert-success', '<p>MAC Staff have been notified and will respond to <strong>' + email + '</strong> within 3 business days. Thank you for your patience.</p>');
            },
            error: function () {
                deleteAll('.loading');
                setMessage('helpForm', null, 'alert-danger', '<strong>An error has occured.</strong> Please try again.');
            }
        });
    }


    return false;
}

// leading edge debounce 5s to prevent duplicate submissions.
var accountResetPassword = _.debounce(function () {

    // Start password reset process
    var email = document.getElementById('inputResetEmail').value;


    $.ajax({
        url: environment.api_host + '/api/auth/user/request_reset_token/',
        type: 'POST',
        contentType: 'application/json',
        xhrFields: {
            withCredentials: true
        },
        data: JSON.stringify({
            email: email.trim(),
            application: environment.application_name
        }),
        success: function (data) {
            if (data.success) {
                setMessage('helpResetPasswordForm', null, 'alert-success',
                    'An email with instructions on how to reset ' +
                    'your password has been to sent to ' + email);
            } else {
                setMessage('helpResetPasswordForm', null, 'alert-success',
                    'Unable to request a password reset.  Please ' +
                    'contact the helpdesk for support');
            }
        },
        error: function () {
            setMessage('helpResetPasswordForm', null, 'alert-danger', '<strong>Unable to reset password.</strong> Please try again..');
        }
    });

    return false;
}, 5000, true);

export { accountResetPassword };

export function getResetToken() {
    var query_params = window.location.search.replace('?', '').split('&').reduce(function (s, c) { var t = c.split('='); s[t[0]] = t[1]; return s; }, {});
    if (! query_params.rp) {
        hideAllPages();
        toggleDisplay(page_helpPasswordReset, 'block');
        setMessage('helpResetPasswordForm', null, 'alert-danger', 
            '<strong>Unable to reset password.</strong> Your password reset'+
            ' token is too old, or has already been used.  Please request a'+
            ' new token using the form shown above, and try again.');
        return false;
    }
    return query_params.rp;
}

export function accountSetNewPassword() {


    // Start password reset process
    var password1 = document.getElementById('newPassword1').value;
    var password2 = document.getElementById('newPassword2').value;
    var token = document.getElementById('newPasswordToken').value;

    
    deleteAll('.message');
    var reset_token=getResetToken()
    if (! reset_token) {
        return false;
    }

    // // Parse all the query params, we need a reset password token, otherwise this isn't valid
    // var query_params = window.location.search.replace('?', '').split('&').reduce(function (s, c) { var t = c.split('='); s[t[0]] = t[1]; return s; }, {});
    // if (! query_params.rp) {
    //     toggleDisplay(page_accountNewPassword, 'none');
    //     toggleDisplay(page_helpPasswordReset, 'block');
    //     setMessage('helpResetPasswordForm', null, 'alert-danger', '<strong>Unable to reset password.</strong> Your password reset token is too old, or has already been used.  Please request a new token and try again.');
    //     return false;
    // }

    if (password1 != password2) {
        setMessage('accountNewPasswordForm', null, 'alert-warning', 'Passwords do not match.');
        return false;
    }
    // var query_params = window.location.search.replace('?', '').split('&').reduce(function (s, c) { var t = c.split('='); s[t[0]] = t[1]; return s; }, {});
    var url = environment.api_host + '/api/auth/user/reset/' + reset_token + '/set-password/';

    $.ajax({
        url: url,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            new_password1: password1,
            new_password2: password2
        }),
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            if (data.success) {
                toggleDisplay(page_accountNewPassword, 'none');
                toggleDisplay(page_login, 'block');
                setMessage('loginMessages', null, 'alert-success', '<strong>Your password has been reset.</strong> Please sign in below.');
            } else {
                deleteAll('.message');
                setMessage('accountNewPasswordForm', 'password-error-danger',
                    'alert-danger', data.error);
                if (data.reason) {
                    setMessage('accountNewPasswordForm', 'password-error-message',
                        'alert-warning', data.reason.join('<br>'));
                }
            }
        },
        error: function () {
            setMessage('accountNewPasswordForm', null, 'alert-danger', '<strong>Unable to reset password.</strong> Please try again..');
        }
    });

    return false;
}

export function addLoading(parent, message) {

    // Add loading/saving message and visual cue
    parent = document.getElementById(parent);
    var d = document.createElement('div');
    d.className = 'message loading';
    // Image loading animated graphic
    d.innerHTML = '<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAAKAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQACgABACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkEAAoAAgAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkEAAoAAwAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkEAAoABAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQACgAFACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQACgAGACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAAKAAcALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />' + message;
    parent.appendChild(d);
}

export function airportWarning() {
    // Add notice about airport
    deleteAll('.message');
    $("#airportOptionAlert .alert").alert('close');
    var icao_code = document.getElementById('icao_code').value;
    if (icao_code == 'KANE') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> Anoka County - Blaine Airport.</strong>');
    }
    if (icao_code == 'KMIC') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> Crystal Airport.</strong>');
    } else if (icao_code == 'KFCM') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> Flying Cloud Airport in Eden Praire, MN.</strong>');
    } else if (icao_code == 'KLVN') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> Airlake Airport in Lakeville, MN.</strong>');
    } else if (icao_code == 'KSTP') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> St. Paul Downtown Airport.</strong>');
    } else if (icao_code == 'K21D') {
        setMessage('airportOptionAlert', null, 'alert-info', 'You have selected <strong> Lake Elmo Airport.</strong>');
    }
}

export function deleteAll(eType) {


    [].forEach.call(document.querySelectorAll(eType), function (e) {
        e.parentNode.removeChild(e);
    });
}

export function initUser() {


    // // Create User using localStorage values if set

    // if (lsTestAvailability() == true) {

    //     if (typeof User != 'undefined') {
    //         User = {};
    //     }

    //     User['api-token'] = null;
    //     User['api-token-expires'] = null;
    //     User.email = null;
    //     User.locations = {};

    //     if (localStorage.getItem('api-token') != null) {
    //         User['api-token'] = localStorage.getItem('api-token');
    //     }

    //     if (localStorage.getItem('api-token-expires') != null) {
    //         User['api-token-expires'] = localStorage.getItem('api-token-expires');
    //     }

    //     if (localStorage.getItem('email') != null) {
    //         User.email = localStorage.getItem('email');
    //     }

    //     if (localStorage.getItem('locations') != null) {
    //         User.locations = JSON.parse(localStorage.getItem('locations'));
    //     }

    //     // UI
    //     document.getElementById(span_accountEmail).innerHTML = User.email;

    // } else {
    //     $('#helpRequirements').modal('show');
    // }

}

export function mapUpdateLocation(lat, lon) {

    basemap.setView([lat, lon], 16);
    mapAddMarker(layers_location_points, lat, lon);
}

export function logIn() {
    if (authStatus && authStatus.authenticated) {
        window.location.hash = '#noise-complaint';
        return false;
    }

    var email = document.getElementById('inputLoginEmail').value;
    var password = document.getElementById('inputLoginPassword').value;

    deleteAll('.message');
    addLoading('loginExistingCustomer', 'Authenticating...');

    $.ajax({
        url: environment.api_host + '/api/auth/user/login/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            email: email.trim(),
            password: password
        }),
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            if (!data['success']) {
                setMessage('loginExistingCustomer', null, 'alert-danger', '<strong>' + data.error +
                    '.</strong><p>Please try again. If you have forgotten your password, please <a href="#account-reset-password">click here</a><br>.</p>');
            } else {
                document.getElementById(span_accountEmail).innerHTML = email.trim();
                authStatus = {};
                
                updateAuthStatus(function () {
                    window.location.hash = '#noise-complaint';
                });

            }
        },
        error: function (data) {
            var response = JSON.parse(data.responseText);
            setMessage('loginExistingCustomer', null, 'alert-danger', '<strong>' + response.message + '.</strong><p>Please try again. If you have forgotten your password, please <a href="#account-reset-password">click here</a>.</p>');
        },
        complete: function () {
            deleteAll('.loading');
        }
    });
    return false;
}

function logOut() {
    authStatus = undefined;
    var url = environment.api_host + '/api/auth/user/logout/';
    $.ajax({
        url: url,
        type: 'GET',
        contentType: 'application/json',
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            authStatus = undefined;
            window.location.hash = '#';
        }
    });
    localStorage.clear();
    // initUser();

}

export function lsSetValue(objectName, value) {


    // if (lsTestAvailability() == true) {} else {
    //     window.location.hash = '#help-requirements';
    // }

    // if (typeof(value) == 'object') {
    //     localStorage.setItem(objectName, JSON.stringify(value));
    // } else {
    //     localStorage.setItem(objectName, value);
    // }

    // if (typeof User != 'undefined') {
    //     initUser();
    // }
    // User[objectName] = value;

}

export function lsTestAvailability() {

    // // Test if local storage is available
    // if (typeof localStorage !== 'undefined') {
    //     try {
    //         localStorage.setItem('feature_test', 'yes');
    //         if (localStorage.getItem('feature_test') === 'yes') {
    //             localStorage.removeItem('feature_test');
    //             return true;
    //         } else {
    //             // localStorage is disabled
    //             return false;
    //         }
    //     } catch (e) {
    //         // localStorage is disabled
    //         return false;
    //     }
    // } else {
    //     // localStorage is not available
    //     return false;
    // }
}

export function mapAddMarker(markerLayer, lat, lon) {

    var thisGeoJSON = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [lon, lat]
        },
        properties: {
            title: '',
            description: '',
            'marker-size': 'small',
            'marker-color': '#3d7fc1'
        }
    };
    markerLayer.clearLayers();
    markerLayer.setGeoJSON(thisGeoJSON);

}


export function populateFormReasons() {
    $('#complaintReasonList').empty();
    // Populate complaint form addresses from locations
    _.each(complaintReasons, function (reason) {
        var reason_html=('<label class="form-check-label">' +
         '	<input class="form-check-input" name="'+ reason.reason + '" id="'+reason.reason+'" ' +
         '    type="checkbox" onChange="clearComplaintReasonError()"> ' +
         reason.description +
		'</label><br>');
        $('#complaintReasonList').append(reason_html);
    });

}

export function populateFormAddresses() {
    $('#address-select').empty();
    // Populate complaint form addresses from locations
    _.each(addresses, function (address) {
        var full_address = address.address;
        if (address.address2) {
            full_address = full_address + ' &middot; ' + address.address2;
        }
        $('#address-select').append('<option value="' + address.id + '">' + full_address + '</value>');
    });

}

export function processNewComplaint() {

    deleteAll('.message');
    addLoading('newComplaintForm', 'Saving...');

    // var opnum = null; // For future use
    // var runway = null; //For future use

    // Data
    var user_location = document.getElementById('address-select').value;
    var re = /([0-9]{1,2}):([0-9]{2})\ ([APMapm]{2})/;
    var complaint_date = document.getElementById('date').value;
    var complaint_time = document.getElementById('time').value.replace(re, '$1:$2');
    var complaint_meridiem = document.getElementById('time').value.replace(re, '$3');

    var formValidation = true;

    // Format date and time
    if (complaint_date.length < 10) {
        setMessage('newComplaintFormDateTime', null, 'alert-warning', 'A valid date is is required.');
        formValidation = false;
    }

    var raw_time = complaint_time.replace(/\D/g, '');
    if (raw_time.length == 4 || raw_time.length == 3) {
        var date_year = parseInt(complaint_date.substr(6, 4));
        var date_month = parseInt(complaint_date.substr(0, 2)) - 1; //Stupid JS
        var date_day = complaint_date.substr(3, 2);
        var date_hours = 0;

        if (raw_time.length == 3) {
            date_hours = parseInt(raw_time.substr(0, 1));
        } else {
            date_hours = parseInt(raw_time.substr(0, 2));
        }

        if (complaint_meridiem == 'AM' && date_hours == 12) {
            date_hours = 0;
        }
        if (complaint_meridiem == 'PM' && date_hours < 12) {
            date_hours = date_hours + 12;
        }
        var date_minutes = parseInt(raw_time.substr(-2));

        if (date_hours > 24 || date_minutes > 59) {
            setMessage('newComplaintFormDateTime', null, 'alert-warning', 'A valid time is required.');
            var formValidation = false;
        } else {
            var raw_d = new Date(date_year, date_month, date_day, date_hours, date_minutes);
            var now = new Date();
            var now_iso8601 = now.toISOString();
            var complaint_iso8601 = raw_d.toISOString();

            if (complaint_iso8601 > now_iso8601) {

                var complaint_string = raw_d.toLocaleDateString() + ' ' + raw_d.toLocaleTimeString();
                var currentTime_string = now.toLocaleDateString() + ' ' + now.toLocaleTimeString();

                setMessage('newComplaintFormDateTime', null, 'alert-warning', '<p><strong>A valid date and time is required.</strong> Date and time can not be in the future.</p><p>Your complaint is for ' + complaint_string + ' and the current time is ' + currentTime_string + '</p>');
                var formValidation = false;
            } else {
                var formValidation = true;
            }


        }
    } else {
        setMessage('newComplaintFormDateTime', null, 'alert-warning', 'A valid time is is required.');
        var formValidation = false;
    }


    // Get all the complaint reasons - and store them as a list of reasons.
    var reasons=[];
    _.each(document.querySelector('#complaintReasonList').querySelectorAll('input'), 
        function (item) {
            if (item.checked) {
                reasons.push(item.name);
            }
    });


    var icao_code = document.getElementById('icao_code').value;
    var ad_flag = document.getElementById('ad_flag').value;

    if (reasons.length == 0) {
        formValidation = false;
        setMessage('complaintReason', null, 'alert-warning', 'At least one reason is required.');
    }

    // Check airport is selected
    if (icao_code == 'select') {
        formValidation = false;
        setMessage('airportOptionAlert', null, 'alert-warning', 'Please select an airport.');
    }
    
    if (formValidation == true) {
        var formData={};
        formData['user_location']=user_location;
        formData['reasons']=reasons;
        formData['icao_code']=icao_code;
        formData['adflag']=ad_flag;
        formData['complaint_date']=complaint_iso8601;


        $.ajax({
            url: environment.api_host + '/api/crm/1/complaint/',
            type: 'POST',
            contentType: 'application/json',
            // beforeSend: function(xhr) {
            //     xhr.setRequestHeader('api-token', User['api-token']);
            // },
            xhrFields: {
                        withCredentials: true
            },
            data: JSON.stringify(formData),
            timeout: 10000,
            success: function (data) {

                // console.log('Store timestamps locally and check that they dont submit the same complaint multiple times?');
                // console.log('Handle failed push to queue - local storage and API call to fetch');

                deleteAll('.loading');
                document.getElementById('newComplaintForm').reset();
                $(".alert").alert('close');
                document.getElementById('dateCheck').innerHTML = '';
                document.getElementById('timeCheck').innerHTML = '';
                window.location.hash = '#complaint-received';

            },
            error: function (data) {
                if (data['status'] == 401) {
                    deleteAll('.loading');
                    setMessage('newComplaintForm', null, 'alert-warning', '<p>Your login has expired. Please <a href="#log-out">click here</a> to sign in again.</p>');
                } else {
                    var response = JSON.parse(data['responseText']);
                    deleteAll('.loading');
                    setMessage('newComplaintForm', null, 'alert-danger', '<p>An error has occured (' + response['message'] + ').</p><p>Please try again.</p>');
                }
            }
        });
    } else {
        deleteAll('.loading');
    }

    return false;
}

export function processNewCustomerForm() {
    // Validate form and send data to backend
    deleteAll('.message');
    addLoading('newComplaintForm', 'Saving...');

    toggleDisplay('newCustomerAccount', 'block'); //load rest of form

    // Data
    var address1 = document.getElementById('finalNewCustomerAddress').value;
    var address2 = document.getElementById('inputNewCustomerAddress2').value;
    // var lat = document.getElementById('inputNewCustomerLat').value;
    // var lon = document.getElementById('inputNewCustomerLon').value;

    var email = document.getElementById('inputNewCustomerEmail').value;
    var email2 = document.getElementById('inputNewCustomerEmail2').value;
    var first_name = document.getElementById('inputNewCustomerFirstName').value;
    var last_name = document.getElementById('inputNewCustomerLastName').value;
    var phone = document.getElementById('inputNewCustomerPhone').value;


    var formValidation = true;

    if (address1.length < 4) {
        setMessage('newCustomerMapInputs', null, 'alert-warning', 'A street address is required.');
        formValidation = false;
    }


    if (email.length < 4) {
        setMessage('newCustomerFormAuth', null, 'alert-warning', 'An email address is required.');
        formValidation = false;
    }

    if (email != email2) {
        setMessage('newCustomerFormAuth', null, 'alert-warning', 'Email addresses do not match.');
        formValidation = false;
    }

    if (!validateEmail(email)) {
        setMessage('newCustomerFormAuth', null, 'alert-warning', 'The email address entered (' + email + ') does not appear to be a valid.');
        formValidation = false;
    }



    if (formValidation == true) {

        var formData = {
            'address': address1,
            'address2': address2,
            'email': email,
            'first_name': first_name,
            'last_name': last_name,
            'phone': phone,
            'application': environment.application_name
        };

        $.ajax({
            url: environment.api_host + '/api/crm/1/user/',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data.success) {
                    deleteAll('.loading');
                    window.location.hash = '#waiting-for-validaton';
                } else {
                    var msgs = [];
                    _.each(data['errors'], function (value, key) {
                        msgs.push(value.join(', '));
                    });
                    setMessage('newCustomerForm', null, 'alert-danger', '<strong>An error has occured.</strong> ' + msgs.join('<br>'));
                }
            }
        });


    }

    return false;
}

export function showAddressHelp() {
    toggleDisplay('helpIntro', 'toggle');
    toggleDisplay('helpForm', 'block');
    return false;
}

export function setMessage(parent, childID, childClasses, childHTML) {
    // Set div.message
    parent = document.getElementById(parent);
    if (parent.getElementsByClassName('alert-warning').length == 0) {
        var error = document.createElement('div');
        error.id = childID;
        error.className = 'col-xs-12 alert alert-dismissable fade show ' + childClasses;
        error.innerHTML = '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> ' + childHTML;
        parent.appendChild(error);
    }
}

export function updateNewCustomerLocationMap(lat, lon) {
    mapUpdateLocation(lat, lon);
}



export function updatePageLocation() {
    hideAllPages(); // Hide all "pages" (div.box)
    deleteAll('.message'); // Delete all message divs
    toggleDisplay(span_accountInfo, 'none'); // Display by default

    if (!authStatus) {
        updateAuthStatus(updatePageLocation);
        return;
    }


    var current_page = window.location.hash;
    var split_hash = current_page.split('?');
    current_page = split_hash[0];

    if ((! authStatus.authenticated) && _.indexOf( ['#complaint-received', 
                '#noise-complaint'], current_page) > -1) {
        // Not logged in - redirect to the login page.
        window.location.hash = '#';
        current_page='';;
    }  
    if (current_page == '' || current_page == '#') {
        if (authStatus.authenticated) {
            window.location.hash = '#noise-complaint';
        } else {
            toggleDisplay(page_login, 'block');
        }
    } else if (current_page == '#account') {
        console.log('Fix this');
        alert('Under development');
    } else if (current_page == '#account-new-password') {
        toggleDisplay(page_login, 'none');
        var reset_token=getResetToken();
        if (reset_token) {
            document.getElementById('newPasswordToken').value=reset_token;
            toggleDisplay(page_accountNewPassword, 'block');
        }
    } else if (current_page == '#account-reset-password') {
        toggleDisplay(page_login, 'none');
        toggleDisplay(page_helpPasswordReset, 'block');

    } else if (current_page == '#account-validation') {

        // Send token to API for validation
        var token = split_hash[1];
        if (token != undefined) {
            accountValidateEmail(token);
        } else {
            setMessage('loginMessages', null, 'alert-danger', '<strong>Unable to validate.</strong> Please try again..');
            toggleDisplay(page_login, 'block');

        }
    } else if (current_page == '#complaint-received') {
        toggleDisplay(page_login, 'none');
        toggleDisplay(page_complaintReceived, 'block');

    } else if (current_page == '#noise-complaint') {
        // if (User['api-token'] == null) {git status
        //     logOut();
        // }
        toggleDisplay(page_login, 'none');
        toggleDisplay(span_accountInfo, 'block'); // Display by default


        populateFormAddresses();
        toggleDisplay(page_createNewComplaint, 'block');

    } else if (current_page == '#log-in') {
        window.location.hash = '#';
    } else if (current_page == '#log-out') {
        logOut();
    } else if (current_page == '#new-account') {
        toggleDisplay(page_login, 'none');
        toggleDisplay(page_createNewCustomer, 'block');

        basemap.invalidateSize(); // https://www.mapbox.com/help/blank-tiles/
    } else if (current_page == '#new-location') {
        toggleDisplay(span_accountInfo, 'block');
        toggleDisplay(page_createNewLocation, 'block');

    } else if (current_page == '#trends') {
        console.log('Under development');
        alert('Under development');
    } else if (current_page == '#waiting-for-validaton') {
        toggleDisplay(page_login, 'none');
        toggleDisplay(page_validateMessageNewCustomer, 'block');
        //setMessage(page_validateMessageNewCustomer, null, 'alert-success', '<p><strong>Your account has been created</strong>, a confirmation email sent to the address supplied.</p><p>You must click the validation link in this email to activate your account before you can sign in.</p>');
    }
}

export function toggleDisplay(target, value) {
    if (value == 'toggle') {
        if (document.getElementById(target).style.display == "block" || document.getElementById(target).style.display == "") {
            value = 'none';
        } else {
            value = 'block';
        }
    }
    document.getElementById(target).style.display = value;
}

export function clearComplaintReasonError() {
    $("#complaintReason .alert").alert('close');
}

export function updateTime() {
    var re = /([0-9]{1,2}):([0-9]{2})\ ([APMapm]{2})/;
    var complaint_date = document.getElementById('date').value;
    var complaint_time = document.getElementById('time').value.replace(re, '$1:$2');
    var complaint_meridiem = document.getElementById('time').value.replace(re, '$3');

    // Check all populated
    var object = {
        'date': complaint_date,
        'time': complaint_time,
        'meridiem': complaint_meridiem
    };
    var valid = true;
    for (var k in object) {
        if (object[k].length < 1) {
            valid = false;
        }
    }

    if (valid == true) {

        var raw_time = complaint_time.replace(/\D/g, '');
        if (raw_time.length == 4 || raw_time.length == 3) {

            // Get date elements
            var date_year = parseInt(complaint_date.substr(6, 4));
            var date_month = parseInt(complaint_date.substr(0, 2)) - 1; //Stupid JS
            var date_day = complaint_date.substr(3, 2);
            var date_hours = 0;

            // Calculate the hours
            if (raw_time.length == 3) {
                date_hours = parseInt(raw_time.substr(0, 1));
            } //Pad 0
            else {
                date_hours = parseInt(raw_time.substr(0, 2));
            }
            if (complaint_meridiem == 'AM' && date_hours == 12) {
                date_hours = 0;
            }
            if (complaint_meridiem == 'PM' && date_hours < 12) {
                date_hours = date_hours + 12;
            }
            var date_minutes = parseInt(raw_time.substr(-2));

            if (parseInt(date_hours) < 24 && date_minutes < 60) {
                var raw_d = new Date(date_year, date_month, date_day, date_hours, date_minutes);

                document.getElementById('dateCheck').innerHTML = raw_d.toLocaleDateString();
                var t = raw_d.toLocaleTimeString();
                document.getElementById('timeCheck').innerHTML = t.substr(0, 5) + ' ' + t.substr(-2);
                $("#newComplaintFormDateTime .alert").alert('close');

            }

        }
    }

}

export function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}


// var api_host = environment.api_host; //Change this line to set api for development

var api_token = 'api-token';
var api_token_expires = 'api-token-expires';
var User = {};

var page_login = 'landing-page';
var page_accountNewPassword = 'accountNewPassword';
var page_accountValidation = 'account-validation';
var page_complaintReceived = 'complaint-received';
var page_createNewComplaint = 'create-new-complaint';
var page_createNewCustomer = 'create-new-customer';
var page_createNewLocation = 'existing-customer-new-location';
var page_helpGeneral = 'helpGeneral';
var page_helpPasswordReset = 'helpPasswordReset';
var page_validateMessageNewCustomer = 'new-customer-validation-notice';

var span_accountInfo = 'spanAccountInfo';
var span_accountEmail = 'accountEmail';
var breadcrumb = 'currentPage';

var formNewCustomer = 'formNewCustomer';
var inputNewAddress = 'inputNewAddress';
var inputNewCustomerAddress = 'inputNewCustomerAddress';




// Map setup
L.mapbox.accessToken = 'pk.eyJ1IjoibXNwbWFjIiwiYSI6ImNqNGZsc3U1ZjE5bmkzM3BzMGFoZHh1dnEifQ.ZUId1x7cwzFK6elr4oHZQw';

var baseMapboxTiles = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=' + L.mapbox.accessToken, {
   attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
   tileSize: 512,
   zoomOffset: -1
});
var aerialMapboxTiles = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=' + L.mapbox.accessToken, {
   attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
   tileSize: 512,
   zoomOffset: -1
});

var basemap = L.mapbox.map('newCustomerMap', null, {
    zoomControl: false
}).addLayer(
	    baseMapboxTiles
).setView([44.92, -93.3], 9);
basemap.scrollWheelZoom.disable();
var layers_location_points = L.mapbox.featureLayer().addTo(basemap);

initUser();
updatePageLocation();
window.onhashchange = updatePageLocation;

//Address autocomplete
$('#inputNewCustomerAddress').autocomplete({
    create: function(evt, ui) {
        $(evt.target).attr('autocomplete','new-password');
    },
    source: function (request, response) {
        var searchFor = document.getElementById('inputNewCustomerAddress').value;
        searchFor = searchFor.replace('/ /g', "-"); // Convert spaces to dash
        var searchURL = environment.api_host + '/api/crm/1/address-lookup/';
        $.ajax({
            url: searchURL,
            type: 'GET',
            data: {
                'address__istartswith': searchFor
            },
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                console.log('Got results', data)
                var results = {};
                _.each(data.objects, function (row) {
                    // The old code returned a WKT geometry, so convert.
                    var geojson = JSON.parse(row.location);
                    var geom = 'POINT(' + geojson.coordinates.join(' ') + ')';
                    results[row.id] = {
                        value: row.address,
                        id: geom
                    }
                });
                response(results);
            }
        });

    },
    minLength: 1,
    select: function (event, ui) {
        var geom = ui.item.id;
        var geom = geom.split(' ');
        var lon = geom[0].substr(6);
        var lat = geom[1].slice(0, -1);

        // Update map
        document.getElementById('inputNewCustomerLat').value = lat;
        document.getElementById('inputNewCustomerLon').value = lon;
        updateNewCustomerLocationMap(lat, lon);

        // Update UI
        toggleDisplay('newCustomerAccount', 'block');
        document.getElementById('addressText').innerHTML = ' for ' + ui.item.value;
        document.getElementById('finalNewCustomerAddress').value = ui.item.label;
        $('#newCustomerMapInputs').append('<span class="status valid">&#10004; Valid</span>');
    },
    open: function () {
        deleteAll('.searching');
        deleteAll('.status');
        $('#newCustomerMapInputs').append('<span class="searching">Searching ...<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAAKAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQACgABACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkEAAoAAgAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkEAAoAAwAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkEAAoABAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQACgAFACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQACgAGACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAAKAAcALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" class="inline"/></span>');
    },
    close: function () {
        deleteAll('.searching');
    },
    response: function (event, ui) {
        deleteAll('.status');
        document.getElementById('inputNewCustomerLat').value = null;
        document.getElementById('inputNewCustomerLon').value = null;
        document.getElementById('finalNewCustomerAddress').value = null;
        if (Object.keys(ui['content']).length == 0) {
            $('#newCustomerMapInputs').append('<span class="status invalid">&#10006; Invalid</span>');
        }
    }
});

